import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Redirect } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import DashboardPageNew from './pages/DashboardPageNew';
import signInPage from './pages/signInPage';
import UsersTablePage from "./pages/UserPages/UsersTablePage";
import RoomsPage from "./pages/roomPages/RoomsPage";
import App from './App';
import MsgsTablePage from "./pages/MsgsTablePage";
import SingleUserPage from "./pages/UserPages/SingleUser";
import SingleStatisticPage from "./pages/StatisticsList/SingleStatistic";
import SingleRoomPage from "./pages/roomPages/SingleRoom";
import ChooseImba from "./pages/ChooseImba";
import TokenAuth from "./pages/TokenAuth";
import SupportNew from "./pages/OnlineSupport/SupportNew";
import SupportWork from "./pages/OnlineSupport/SupportWork";
import ChangeStatus from "./pages/OnlineSupport/ChangeStatus";
import FilterPage from "./pages/FilterPage/FilterPage";
import MessageListPage from "./pages/MessageList/MessageListPage";
import NoteListPage from "./pages/NoteList/NoteListPage";
import StatisticsListPage from "./pages/StatisticsList/StatisticsListPage";
import FalsePage from "./pages/FalsePage";


function PrivateRoute ({component: Component, ...rest}) {
  return (
      <Route
          {...rest}
          render={(props) => {
            let href = props.location.pathname // Наша псевдоссылка
            let reg = href.replace(/^\/(\d+)\#?.*$/, '$1');
            let pathname = /^\d+$/.test(reg) ? `/${reg}/signIn` : '/'
            return  localStorage.getItem('comet-token') ? (
                <Component {...props} />
                ) :
                (
                    <Redirect to={{pathname: pathname, state: {from: props.location}}} />
                    )
          }}
      />
  )
}
ReactDOM.render(
    <Router>
      <App>
        <PrivateRoute exact key="index" path="/:imba_id" component={DashboardPage} />
        <Route exact key="signIn" path="/:imba_id/signIn" component={signInPage} />
        <Route exact key="main" path="/" component={ChooseImba} />
        <PrivateRoute exact key="users" path="/:imba_id/users" component={UsersTablePage} />
        <PrivateRoute exact key="rooms" path="/:imba_id/rooms" component={RoomsPage} />
        <PrivateRoute exact key="statistics" path="/:imba_id/statistics" component={StatisticsListPage} />
        <PrivateRoute exact key="messages" path="/:imba_id/messages" component={MsgsTablePage} />
        <PrivateRoute exact key="single_user" path="/:imba_id/user/:id" component={SingleUserPage} />
        <PrivateRoute exact key="single_statistic" path="/:imba_id/statistic/:id" component={SingleStatisticPage} />
        <PrivateRoute exact key="single_room" path="/:imba_id/room/:id" component={SingleRoomPage} />
        <PrivateRoute exact key="list_new" path="/:imba_id/list" component={MessageListPage} />
        <PrivateRoute exact key="note_new" path="/:imba_id/note" component={NoteListPage} />
        <PrivateRoute exact key="test" path="/:imba_id/test" component={SingleRoomPage}/>
        <PrivateRoute exact key="support_new" path="/:imba_id/support_new" component={SupportNew} />
        <PrivateRoute exact key="support_work" path="/:imba_id/support_work" component={SupportWork} />
        <PrivateRoute exact key="change_status" path="/:imba_id/change_status" component={ChangeStatus} />
        <PrivateRoute exact key="index_test" path="/:imba_id/test_new" component={DashboardPageNew} />
        <PrivateRoute exact key="index_false" path="/false" component={FalsePage} />
        <PrivateRoute exact key="filter_page" path="/:imba_id/filter" component={FilterPage} />
        <Route exact key="auth_token" path="/:imba_id/auth/:token" component={TokenAuth}/>
      </App>
    </Router>, // eslint-disable-next-line no-undef
  document.getElementById('root')
);
